import { i18n } from "@tellescope/i18n";
import type { FreeformFieldOption } from "@tellescope/utils";

export const getCalendarEventFieldOptions: () => FreeformFieldOption[] = () => [
  { value: "title", label: i18n.t("Title", { ns: "calendar" }), valueType: "string" },
  { value: "description", label: i18n.t("Description", { ns: "calendar" }), valueType: "string" },
  { value: "location", label: i18n.t("Location", { ns: "calendar" }), valueType: "string" },
  { value: "locationURL", label: i18n.t("Location URL", { ns: "calendar" }), valueType: "string" },
  { value: "phone", label: i18n.t("Phone", { ns: "calendar" }), valueType: "string" },
  { value: "locationNotes", label: i18n.t("Location Notes", { ns: "calendar" }), valueType: "string" },
  { value: "internalNotes", label: i18n.t("Internal Notes", { ns: "calendar" }), valueType: "string" },
  { value: "reason", label: i18n.t("Reason", { ns: "calendar" }), valueType: "string" },
  { value: "color", label: i18n.t("Color", { ns: "calendar" }), valueType: "string" },
  { value: "templateId", label: i18n.t("Template ID", { ns: "calendar" }), valueType: "string" },
  { value: "creator", label: i18n.t("Creator", { ns: "calendar" }), valueType: "string" },
  { value: "durationInMinutes", label: i18n.t("Duration (minutes)", { ns: "calendar" }), valueType: "number" },
  { value: "actualDuration", label: i18n.t("Actual Duration (minutes)", { ns: "calendar" }), valueType: "number" },
  { value: "startTimeInMS", label: i18n.t("Start Time", { ns: "calendar" }), valueType: "date" },
  { value: "cancelledAt", label: i18n.t("Cancelled At", { ns: "calendar" }), valueType: "date" },
  { value: "noShowedAt", label: i18n.t("No-Showed At", { ns: "calendar" }), valueType: "date" },
  { value: "rescheduledAt", label: i18n.t("Rescheduled At", { ns: "calendar" }), valueType: "date" },
  { value: "createdAt", label: i18n.t("Created At", { ns: "calendar" }), valueType: "date" },
  { value: "updatedAt", label: i18n.t("Updated At", { ns: "calendar" }), valueType: "date" },
];
